import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 35%;
`;

export const Text = styled.p`
  font-size: 2rem;
  text-align: center;
  margin-top: -1rem;
`;
